export const instrumentationShiftScreenName = {
    SchedulesPage: "SchedulesPage",
    RequestsPage: "RequestsPage",
    OtherOpenShiftsPage: "OtherOpenShiftsPage",
    ViewShiftRequestDetails: "ViewShiftRequestDetails",
    CreateTimeOffRequest: "CreateTimeOffRequest",
    ViewBalanceForUsers: "ViewBalanceForUsers"
};